// libraries.
import { Modal, Button } from "react-bootstrap";
import { electricPurple500, monserratSemiBold } from "@habitech/shared";

// interfaces.
import { RawRuleItem } from "@store/apiSlices/incentiveRules/interfaces/rawRules.interfaces";

// styles.
import { StyledRulesModalForm } from "../styles";

interface Props {
  rawRule: RawRuleItem | null;
  onConfirm: () => void;
  onClose: () => void;
}

export const ConfirmToggleModal = ({ rawRule, onConfirm, onClose }: Props) => {
  if (!rawRule) return null;

  const isActive = rawRule.is_active === "active";
  const action = isActive ? "desactivar" : "activar";
  const actionLabel = isActive ? "Desactivar" : "Activar";

  return (
    <Modal show onHide={onClose} centered>
      <Modal.Header
        closeButton
        style={{ borderBottom: `2px solid ${electricPurple500}` }}
      >
        <Modal.Title
          style={{ fontFamily: monserratSemiBold, fontWeight: 600, fontSize: 16 }}
        >
          {actionLabel} regla
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <StyledRulesModalForm>
          <p className="mb-1" style={{ fontSize: 14 }}>
            ¿Estás seguro de que deseas <strong>{action}</strong> la siguiente regla?
          </p>
          <p className="mb-0" style={{ fontSize: 13, color: "#6c757d" }}>
            <code>{rawRule.rule_id}</code> — {rawRule.rule.name}
          </p>
        </StyledRulesModalForm>
      </Modal.Body>

      <Modal.Footer style={{ borderTop: "1px solid #eee" }}>
        <Button className="btn-habi-white" onClick={onClose}>
          Cancelar
        </Button>
        <Button className="btn-habi" onClick={onConfirm}>
          {actionLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
